import { Facebook, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { WhatsAppIcon } from "../site/social";

// Subtle "Share this trip" control — text label + three small icon buttons.
export default function ShareTrip({ tone = "dark", className = "" }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href.split("#")[0] : "https://apuseniactive.ro/en/apuseni-emtb-holidays-romania";
  const text = t("holidays.share.text");
  const light = tone === "light";
  const btn = `inline-flex items-center justify-center w-9 h-9 border transition-colors duration-300 ${
    light ? "border-forest/25 text-forest hover:bg-forest hover:text-bone" : "border-bone/25 text-bone/80 hover:bg-bone hover:text-forest"
  }`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(t("holidays.share.copied"));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t("holidays.share.copy_error"));
    }
  };

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="share-trip">
      <span className={`text-[10px] uppercase tracking-wider-3 ${light ? "text-moss" : "text-bone/50"}`}>{t("holidays.share.label")}</span>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
        target="_blank" rel="noopener noreferrer" aria-label="Share on WhatsApp" title="WhatsApp"
        data-testid="share-whatsapp" className={btn}
      >
        <WhatsAppIcon className="w-4 h-4" />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" title="Facebook"
        data-testid="share-facebook" className={btn}
      >
        <Facebook className="w-4 h-4 stroke-[1.5]" />
      </a>
      <button type="button" onClick={copy} aria-label="Copy link" title={t("holidays.share.copy")} data-testid="share-copy" className={btn}>
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4 stroke-[1.5]" />}
      </button>
    </div>
  );
}
